import { Api } from '@/utils/Api'
import setEntities from '@/utils/SetEntities'
import UrlStore from '@/utils/UrlStore'
import { normalize, schema } from 'normalizr'
import Vue from 'vue'

export const PRINTERS_LOAD = 'PRINTERS_LOAD'
export const PRINTER_LOAD = 'PRINTER_LOAD'
export const PRINTER_CREATE = 'PRINTER_CREATE'
export const PRINTER_UPDATE = 'PRINTER_UPDATE'
export const PRINTER_DESTROY = 'PRINTER_DESTROY'
export const PRINTER_STATE_UPDATE = 'PRINTER_STATE_UPDATE'

const printersApi = new Api(UrlStore.PRINTERS)
const printerSchema = new schema.Entity('printers')

export const extractPrinters = (context, points) => {
  let printers = []
  points.forEach((point) => {
    if (point.printer) {
      printers.push(point.printer)
      point.printer = point.printer.id
    }
  })
  if (printers.length) {
    context.commit('printer/' + PRINTERS_LOAD, { items: printers }, { root: true })
  }
}

export default {
  namespaced: true,
  state: {
    printersLoaded: false,
    printersList: [],
    entities: {
      printers: {}
    }
  },
  getters: {
    printers(state) {
      return state.printersList.map((bId) => state.entities.printers[bId])
    },
    getPrinter: (state) => (printerId) => state.entities.printers[printerId] || null
  },
  mutations: {
    [PRINTERS_LOAD](state, payload) {
      let normData = normalize(payload.items, [printerSchema])
      state.printersList = normData.result
      setEntities(state, normData)
    },
    [PRINTER_LOAD](state, payload) {
      let normData = normalize(payload, printerSchema)
      setEntities(state, normData)
    },
    [PRINTER_CREATE](state, printer) {
      state.printersList.push(printer.id)
      Vue.set(state.entities.printers, printer.id, printer)
    },
    [PRINTER_UPDATE](state, printer) {
      if (printer.id && state.entities.printers[printer.id]) {
        state.entities.printers[printer.id] = Object.assign({}, state.entities.printers[printer.id], printer)
      }
    },
    [PRINTER_DESTROY](state, printer) {
      let num = state.printersList.findIndex((cId) => cId === printer.id)
      if (num !== -1) {
        state.printersList.splice(num, 1)
        delete state.entities.printers[printer.id]
      }
    },
    [PRINTER_STATE_UPDATE](state, data) {
      for (let name of Object.keys(data)) {
        state[name] = data[name]
      }
    }
  },
  actions: {
    printersLoad({ commit }, config = {}) {
      printersApi.getAll(config).then((r) => {
        commit(PRINTERS_LOAD, r.data)
        commit(PRINTER_STATE_UPDATE, { printersLoaded: true })
      })
    },
    printerLoad({ commit }, config) {
      printersApi.get({ id: config.id, config: config }).then((r) => {
        commit(PRINTER_LOAD, r.data)
      })
    },
    printerSave({ commit, getters }, { printer, config = {} }) {
      if (!printer.id) throw new Error('Printer id is not present in `printerSave`!')
      commit(getters.getPrinter(printer.id) ? PRINTER_UPDATE : PRINTER_CREATE, printer)
      let printerUpdated = getters.getPrinter(printer.id)

      return printersApi.save(printerUpdated, config).then((r) => {
        if (r._isNew) {
          commit(PRINTER_DESTROY, printerUpdated) // local
          commit(PRINTER_CREATE, r.data)
          if (r.data.point_id) {
            commit(`point/POINT_UPDATE`, { id: r.data.point_id, printer: r.data.id }, { root: true })
          }
        } else {
          commit(PRINTER_UPDATE, r.data)
        }
        return r.data.id
      })
    },
    printerDestroy({ commit }, printer) {
      printersApi.destroy({ id: printer.id }).then(() => {
        commit(PRINTER_DESTROY, printer)
      })
    }
  }
}
